import { format,parse,differenceInSeconds } from 'date-fns';

export class DriveScheduleItem {
    id:any = 0;
    idRow:any = 0;
    idxRow:number = -1;
    dtgUnitId:string = "";
    dtgRegDt:string = "";
    dtgRegDtYy:number = 0;
    dtgRegDtMm:number = 0;
    dtgRegDtDd:number = 0;
    dtgRegDtHh:number = 0;
    dtgRegDtFrom:string = "";
    dtgRegDtTo:string = "";
    dtgCarNo:string = "";
    dtgCarType:string = "";
    dtgCarTypeNm:string = "";
    userId:string = "";
    userNm:string = "";
    userBirthDt:string = "";
    userHireDt:string = "";
    companyId:string = "";
    companyNm:string = "";
    dtgEid:string = "";
    tid:string = "";
    ccd:string = "";
    teamId:string = "";
    drivePathNm:string = "";
    drivePathFromNm:string = "";
    drivePathToNm:string = "";
    import(resItem){
        for(let key1 in resItem){
            if(this.hasOwnProperty(key1) === true){
                this[key1] = resItem[key1];
            }
        }
    };
    getDtFromScheduleDate(){
        return parse(this.dtgRegDtFrom,"yyyy-MM-dd HH:mm:ss",new Date());//배차시작
    };
    getDtToScheduleDate(){
        return parse(this.dtgRegDtTo,"yyyy-MM-dd HH:mm:ss",new Date());//배차종료
    };
    getDtFromScheduleTxt(){
        return this.dtgRegDtFrom;
    };
    getDtToScheduleTxt(){
        return this.dtgRegDtTo;
    }
    getDurSecSchedule(){
        return differenceInSeconds(this.getDtToScheduleDate(),this.getDtFromScheduleDate());
    };
    getDurMinuteSchedule(){
        return Math.floor(this.getDurSecSchedule() / 60);
    }
}